window.addEventListener('DOMContentLoaded', () => {
  // ============================================================
  // フロート SNSアイコン
  // ============================================================
  // 監視対象要素
  const footerElement = document.querySelector("footer");
  const socialMediaElement = document.querySelector(".social-media.custom-float");

  if(socialMediaElement) {
    // 交差時に実行される関数
    const doWhenIntersect = entries => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          socialMediaElement.style.opacity = '0';
        } else {
          socialMediaElement.style.opacity = '1';
        }
      });
    };
  
    // IntersectionObserverのオプション
    const options = {
      root: null,
      rootMargin: '0px', // 要素が画面に入ったら監視する
      threshold: 0
    };
  
    // footer要素を監視
    const observer = new IntersectionObserver(doWhenIntersect, options);
    observer.observe(footerElement);
  }
  
  // ============================================================
  // ヘッダー メガメニュー表示
  // ============================================================
  var navItems = document.querySelectorAll('.header__primary-nav-item.custom');
  var megaMenus = document.querySelectorAll('.mega-menu.custom');
  var heightObserver = document.querySelector('height-observer');
  var currentHoverItem = null;

  navItems.forEach(function(navItem) {
    navItem.addEventListener('mouseenter', function() {
      var title = navItem.getAttribute('data-title');
      hideAllMegaMenus();
      var megaMenu = document.querySelector('.mega-menu.custom[data-title="' + title + '"]');
      if (megaMenu) {
        megaMenu.style.opacity = '1';
        megaMenu.style.visibility = 'visible';
        currentHoverItem = navItem;
      }
    });

    navItem.addEventListener('mouseleave', function(event) {
      var relatedTarget = event.relatedTarget;
      if (!isHoveringOverMegaMenu(relatedTarget) && !isHoveringOverParent(relatedTarget)) {
        hideAllMegaMenus();
      }
    });
  });

  megaMenus.forEach(function(megaMenu) {
    megaMenu.addEventListener('mouseenter', function() {
      var title = megaMenu.getAttribute('data-title');
      var navItem = document.querySelector('.header__primary-nav-item.custom[data-title="' + title + '"]');
      if (navItem) {
        navItem.classList.add('hovered');
      }
      megaMenu.style.opacity = '1';
      megaMenu.style.visibility = 'visible';
    });

    megaMenu.addEventListener('mouseleave', function(event) {
      var relatedTarget = event.relatedTarget;
      if (!isHoveringOverParent(relatedTarget)) {
        hideAllMegaMenus();
      }
    });
  });

  heightObserver.addEventListener('mouseleave', function(event) {
    var relatedTarget = event.relatedTarget;
    if (!isHoveringOverMegaMenu(relatedTarget)) {
      hideAllMegaMenus();
    }
  });

  function hideAllMegaMenus() {
    megaMenus.forEach(function(megaMenu) {
      megaMenu.style.opacity = '0';
      megaMenu.style.visibility = 'hidden';
    });
    if (currentHoverItem) {
      currentHoverItem.classList.remove('hovered');
    }
    currentHoverItem = null;
  }

  function isHoveringOverMegaMenu(element) {
    while (element) {
      if (element.classList && element.classList.contains('mega-menu')) {
        return true;
      }
      element = element.parentElement;
    }
    return false;
  }

  function isHoveringOverParent(element) {
    while (element) {
      if (element === heightObserver) {
        return true;
      }
      element = element.parentElement;
    }
    return false;
  }

  // ============================================================
  // ヘッダー 背景色変更
  // ============================================================
  // 監視対象要素
  const sliderElement = document.querySelector(".main-slider");
  const frontHeaderElement = document.querySelector(".front-header");
  const headerElement = document.querySelector(".header-container");
  
  if (frontHeaderElement && sliderElement) {
    // 交差時に実行される関数
    const doWhenIntersect = entries => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          headerElement.classList.remove('header-blur');
          frontHeaderElement.classList.remove('background-wh');
        } else {
          headerElement.classList.add('header-blur');
          frontHeaderElement.classList.add('background-wh');
        }
      });
    };
  
    // IntersectionObserverのオプション
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };
  
    // sliderElementを監視
    const observer = new IntersectionObserver(doWhenIntersect, options);
    observer.observe(sliderElement);
  } else {
    headerElement.classList.add('header-blur');
  }

  // ============================================================
  // トップページ ブログカード アニメーション
  // ============================================================
  const cardElements = document.querySelectorAll(".blog__item");

  if(cardElements) {
    // 交差時に実行される関数
    const doWhenIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // エントリのターゲットを取得
          const target = entry.target;
  
          // すぐに表示する
          target.style.opacity = '1';
          // target.style.translate = '0 0';
  
          observer.unobserve(target); // 一度表示されたら監視を停止
        }
      });
    };
  
    // IntersectionObserverのオプション
    const options = {
      root: null,
      rootMargin: '0px 0px -5% 0px', // 下部3%に到達
      threshold: 0
    };
  
    // カード要素を監視
    const observer = new IntersectionObserver(doWhenIntersect, options);
    cardElements.forEach(card => {
      observer.observe(card);
    });
  }


  // ============================================================
  // 記事詳細ページ　スライダー
  // ============================================================
  const sectionSlider1 = document.querySelector("#slider1");
  const projectSliderElement = document.querySelector(".project-slider");
  const projectSlides = document.querySelectorAll(".project-slider .project-slider__slide");
  if (projectSlides.length > 1) {
    if (projectSliderElement) {
      const projectSlider = new Splide(projectSliderElement, {
      autoplay: true, // 自動再生
      type: "loop", // ループ
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
      interval: 2000, // 自動再生の間隔
      speed: 1000, // スライダーの移動時間
      autoWidth: true,
      gap: 40, // スライド間の余白
      padding: {
        left: 'calc(230 / 1920 * 140%)', // 左側のパディング
        right: 'calc(230 / 1920 * 100%)', // 左側のパディング
      },
      breakpoints: {      
        767: {
          padding: {
            left: 'calc(40 / 375 * 100%)',
            right: 'calc(40 / 375 * 100%)',
          },
          gap: 4,
          arrows: false,
        },
      }
      }).mount();
    }
  } else if (projectSlides.length === 1) {
    const singleSlide = projectSlides[0];
    const imgElement = singleSlide.querySelector('img');
    sectionSlider1.innerHTML = '';
    sectionSlider1.appendChild(imgElement);
    imgElement.classList.add('is-pc');
    imgElement.style.maxWidth = '100%';
    imgElement.style.marginInline = 'auto';
    projectSliderElement.remove();
  }

  const projectSliderSpElement = document.querySelector(".project-slider-sp");    
  const projectSlidesSp = document.querySelectorAll(".project-slider-sp .project-slider__slide");
  if (projectSlidesSp.length > 1) {
    if (projectSliderSpElement) {
      const projectSliderSp = new Splide(projectSliderSpElement, {
        autoplay: true, // 自動再生
        type: "loop", // ループ
        pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
        pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
        interval: 2000, // 自動再生の間隔
        speed: 1000, // スライダーの移動時間
        autoWidth: true,
        gap: 40, // スライド間の余白
        focus: 'center',
        padding: {
          left: 'calc(230 / 1920 * 140%)', // 左側のパディング
          right: 'calc(230 / 1920 * 100%)', // 左側のパディング
        },
        breakpoints: {      
          767: {
            padding: {
              left: 'calc(10 / 390 * 100%)',
              right: 'calc(10 / 390 * 100%)',
            },
            gap: 4,
            arrows: false,
          },
        }
      }).mount();
    }
  } else if (projectSlidesSp.length === 1) {
    const singleSlideSp = projectSlidesSp[0];
    const imgElementSp = singleSlideSp.querySelector('img');
    // sectionSlider1.innerHTML = '';
    sectionSlider1.appendChild(imgElementSp);
    imgElementSp.classList.add('is-sp');
    imgElementSp.style.maxWidth = '100%';
    imgElementSp.style.marginInline = 'auto';
    projectSliderSpElement.remove();
  }
  
  const sectionSlider2 = document.querySelector("#slider2");
  const profileSliderElement = document.querySelector(".profile-slider");    
  const profileSlides = document.querySelectorAll(".profile-slider .profile-slider__slide");
  if (profileSlides.length > 1) {    
  if (profileSliderElement) {
    const profileSlider = new Splide(profileSliderElement, {
    autoplay: true, // 自動再生
    type: "loop", // ループ
    pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
    pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
    interval: 2000, // 自動再生の間隔
    speed: 1000, // スライダーの移動時間
    autoWidth: true,
    gap: 40, // スライド間の余白
    focus: 'center',
    padding: {
      left: 'calc(230 / 1920 * 140%)', // 左側のパディング
      right: 'calc(230 / 1920 * 100%)', // 左側のパディング
    },
    breakpoints: {
      767: {
        padding: {
          left: 'calc(10 / 390 * 100%)',
          right: 'calc(10 / 390 * 100%)',
        },
        gap: 4,
        arrows: false,
      },
    }
  }).mount();
}
  } else if (profileSlides.length === 1) {
    const singleProfileSlide = profileSlides[0];
    const imgProfileElement = singleProfileSlide.querySelector('img');
    sectionSlider2.innerHTML = '';
    sectionSlider2.appendChild(imgProfileElement);
    imgProfileElement.style.display = 'block';
    imgProfileElement.style.maxHeight = '600px';
    imgProfileElement.style.marginInline = 'auto';
    profileSliderElement.remove();
  }

  // ============================================================
  // 記事詳細ページ id へ 画像・スライダーを移動
  // ============================================================
    setTimeout(function() {
      const imgElement = document.querySelector('.article-story__fullwide');
      const targetImgElement = document.getElementById('full-wide-image');
      if (imgElement && targetImgElement) {
        targetImgElement.appendChild(imgElement);
      }
      
      const sliderElement = document.querySelector('.project-slider');
      const sliderElementSp = document.querySelector('.project-slider-sp');
      const targetSlider1Element = document.getElementById('slider1');  
      if (sliderElement && targetSlider1Element) {
        targetSlider1Element.appendChild(sliderElement);
      }
      if (sliderElementSp && targetSlider1Element) {
        targetSlider1Element.appendChild(sliderElementSp);
      }
      
      const profileElement = document.querySelector('.profile-slider');
      const targetSlider1Element2 = document.getElementById('slider2');  
      if (profileElement && targetSlider1Element2) {
        targetSlider1Element2.appendChild(profileElement);
      }

      
    }, 1000); // 1秒遅延させる


  // ============================================================
  // 商品概要ページ
  // ============================================================
  const productMvSliderElement = document.querySelector(".product-mv-slider");    
  if (productMvSliderElement) {
    const productMvSlider = new Splide(productMvSliderElement, {
      // autoplay: true, // 自動再生
      type: "loop", // ループ
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
      interval: 2000, // 自動再生の間隔
      speed: 1000, // スライダーの移動時間
      gap: 40, // スライド間の余白
      focus: 'center', // 中央のスライドをフォーカス
      padding: {
        right: 'calc(460 / 1920 * 100%)', // 右側のパディング
        left: 'calc(460 / 1920 * 100%)', // 左側のパディング
      },
      breakpoints: {
        767: {
          arrows: false,
          gap: 4,
          padding: {
            right: 'calc(20 / 390 * 100%)', // 右側のパディング
            left: 'calc(20 / 390 * 100%)', // 左側のパディング
          },
        },
      }
    }).mount();
  }
  

  // 商品スライダー
  const productMainSliderElement = document.querySelector(".product-main-slider");
  let productMainSlider;

  if (productMainSliderElement) {
    productMainSlider = new Splide(productMainSliderElement, {
      type      : 'fade',
      rewind    : true,
      pagination: false,
      arrows    : false,
    });
  }
  
  const productThumbnailElement = document.querySelector(".product-thumbnail-slider");
  let productThumbnail;

  if (productMainSliderElement) {
    productThumbnail = new Splide( '.product-thumbnail-slider', {
      fixedWidth: 130,
      gap       : 4,
      rewind    : true,
      pagination: false,
      arrows    : false,
      isNavigation: true,
    });
  }
  
  if(productMainSliderElement && productThumbnailElement) {
    productMainSlider.sync( productThumbnail );
    productMainSlider.mount();
    productThumbnail.mount();
  }

  
  // アコーディオン  
  const initializeDetailsAccordion = (details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('summary + *');
  
    if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる
  
    let isTransitioning = false; // 連打防止フラグ
  
    const onOpen = () => {
      if (details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      details.setAttribute('open', '');
      panel.style.blockSize = '0px';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = `${panel.scrollHeight}px`;
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    const onClose = () => {
      if (!details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.blockSize = `${panel.scrollHeight}px`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = '0';
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          details.removeAttribute('open');
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    summary.addEventListener('click', (event) => {
      event.preventDefault();
  
      if (details.open) {
        onClose();
      } else {
        onOpen();
      }
    });
  };
  
  document.querySelectorAll('.product-summary-info__accordion').forEach((accordion) => {
    initializeDetailsAccordion(accordion);
  });
});
